import React, { useState, useEffect } from "react";
import "./LocationComponent.css";
import "leaflet/dist/leaflet.css";
import Layout from "../../components/Layout";
import book from '../../images/book.png';
import home_therapy from '../../images/home-therapy.png';
import calling from '../../images/calling.png';
import embrunMap from '../../images/embrunMap.png';
import ottawaMap from '../../images/ottawaMap.png';
import kemptvilleMap from '../../images/kemptvilleMap.png';
import millsMap from '../../images/millsMap.png';
import carletonplaceMap from '../../images/carletonplaceMap.png';
import chestervilleMap from '../../images/chestervilleMap.png';
import clinic from '../../images/clinic.png';
import email from '../../images/email.png';
import call from '../../images/call.png';
import ottawa from '../../images/ottawa-sunset1.jpg';
import location from '../../images/location.png';
import location_illustrator from '../../images/location-illustartor.jpg';
import { useNavigate } from 'react-router-dom';
import QuotesSlider from '../Landingpage/QuotesSlider';

const LocationComponent = () => {
  const [mapImg, setMap] = useState(ottawaMap);
  const locations = [
    { name: "Ottawa", map: ottawaMap, link: "https://www.google.com/maps/place/Ottawa" },
    { name: "Clinic", map: clinic, link: "https://www.google.com/maps/place/6206+Perth+St+unit+e,+Richmond,+ON+K0A+2Z0/@45.1915955,-75.8422183,16z/data=!3m1!4b1!4m6!3m5!1s0x4ccdfa15847aaaab:0xf03835c3ff08a9d4!8m2!3d45.1915955!4d-75.8422183!16s%2Fg%2F11tggf2194?entry=ttu&g_ep=EgoyMDI1MDEyMi4wIKXMDSoASAFQAw%3D%3D" },
    { name: "Kemptville", map: kemptvilleMap, link: "https://www.google.com/maps/place/Kemptville" },
    { name: "Mississippi Mills", map: millsMap, link: "https://www.google.com/maps/place/Mississippi+Mills" },
    { name: "Carleton Place", map: carletonplaceMap, link: "https://www.google.com/maps/place/Carleton+Place" },
    { name: "Embrun", map: embrunMap, link: "https://www.google.com/maps/place/Embrun" },
    { name: "Chesterville", map: chestervilleMap, link: "https://www.google.com/maps/place/Chesterville" },
  ];
  const currentLocation = locations.find(location => location.map === mapImg);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className="location-container">
        <div className="cover-image" style={{ backgroundImage: `url(${ottawa})` }}>
          <h1 className="location-heading">MantraFlex In-Home Physiotherapy in Ottawa</h1>
        </div>
        <div className="delivery-div">
          <div className="delivery">
            <div className="delivery-content">
              <p>
                Discover the convenience and effectiveness of in-home physiotherapy services tailored for the Ottawa region. 
                Whether you're recovering from an injury, managing a chronic condition, or aiming to improve your mobility, 
                our expert physiotherapist bring personalized care to the comfort of your home.
              </p>
              <h2>Book Your Appointment Today</h2>
              <p>
                Take the first step toward better health and mobility without leaving your home. Contact us to book your in-home 
                physiotherapy session in Ottawa. Our team is here to help you achieve your goals with care and compassion.
              </p>
              <button
                className="button primary"
                onClick={() => window.location.href = 'https://mantraflexinc.janeapp.com/'}
              >
                Book an Appointment
              </button>
              <h2>Meet Our Expert Therapist</h2>
              <p>
                Our licensed physiotherapist is highly trained and experienced in delivering in-home care. We bring 
                all the necessary equipment and expertise to create a seamless and effective therapy experience.
              </p>
              <button className="location-book-button" onClick={() => navigate('/clinic')}>Know About Therapist</button>
            </div>
            <div className="delivery-image">
              <img src={location_illustrator} />
            </div>
          </div>
        </div>
        {/* <div className="contact-div"> */}
          {/* <div className="contact-section">
            <h2>Contact Us Below</h2>
            <div className="contact-detail">
              <div className="contact-item">
                <div className="icon-div">
                  <img src={call} alt="Phone" />
                </div>
                <p>+1 613(979)-2402</p>
              </div>
              <div className="contact-item">
                <div className="icon-div">
                  <img src={email} alt="Email" />
                </div>
                <p>info@mantraflex.com</p>
              </div>
            </div>
          </div> */}
          {/* <div className="partner">
            <div className="partner-image">
              <img src={location}/>
            </div>
            <div className="partner-content">
              <h2>Clinic Location</h2>
              <h3 className="clinic-name">6206 Perth St unit e, Richmond, ON K0A 2Z0</h3>
              <p>(Operating Under Pure Massage & Holistic Therapies)</p>
            </div>
          </div> */}
        {/* </div> */}
        <div className="steps-div">
          <h1 className='stepTitle'>How Does MantraFlex In-Home Physiotherapy Work?</h1>
          <div className='steps'>
            {[
              { step: 1, img: book, text: "Book an Appointment here", button: "Book an Appointment" },
              { step: 2, img: calling, text: "We will contact you to know more about you and schedule an appointment if not scheduled yet or alter the appointment if needed." },
              { step: 3, img: home_therapy, text: "Your physiotherapist will come to your home to initiate your treatment plan and guide you toward improved health and mobility." }
            ].map((item, index) => (
              <div className='step' key={index}>
                <div className='step-heading'>
                  <div>Step {item.step}</div>
                </div>
                <div className='step-img'>
                  <img src={item.img} alt={`Step ${item.step}`} />
                </div>
                <div className='step-intro'>
                  <p>{item.text}</p>
                  {item.button && <button onClick={() => window.location.href = 'https://mantraflexinc.janeapp.com/'}  className="button primary">{item.button}</button>}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="location-div">
          <h2>MantraFlex serves these locations</h2>
          <div className="locations">
            {locations.map((location, index) => (
              <div
                key={index}
                className="location"
                onClick={() => setMap(location.map)} // Update the map image when a location is clicked
              >
                {location.name}
              </div>
            ))}
          </div>
        </div>
        <div className="map-div">
          <h2>We Offer Home Physiotherapy in Ottawa & Surrounding Area</h2>
          <div className="mapContainer">
            {currentLocation ? (
              <a
                href={currentLocation.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={mapImg} alt={`Map of ${currentLocation.name}`}/>
              </a>
            ) : (
              <></>
            )}
          </div>
        </div>
        <QuotesSlider />
      </div>
    </Layout>
  );
};

export default LocationComponent;
